import React from 'react';

import { cn } from '@/shared/lib/tailwind-merge';

export const BaseSkeleton = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
    return <div className={cn('animate-pulse rounded-md bg-gray-300', className)} {...props} />;
};
